import _asyncToGenerator from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/builds/ThemaOptical/nuovo-osix-configurator/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import "core-js/modules/web.timers.js";
import "regenerator-runtime/runtime.js";
import { __decorate } from "tslib";
import Component from "vue-class-component";
import Vue from "vue";

var LoginDialog = /*#__PURE__*/function (_Vue) {
  _inherits(LoginDialog, _Vue);

  var _super = _createSuper(LoginDialog);

  function LoginDialog() {
    var _this;

    _classCallCheck(this, LoginDialog);

    _this = _super.apply(this, arguments);
    _this.loginForm = {
      username: "",
      password: ""
    };
    _this.rules = {
      username: [{
        required: true,
        message: "Il codice cliente è obbligatorio",
        trigger: "blur"
      }],
      password: [{
        required: true,
        message: "La password è obbligatoria",
        trigger: "blur"
      }]
    };
    _this.genericLoginError = "";
    return _this;
  }

  _createClass(LoginDialog, [{
    key: "loginDialog",
    get: function get() {
      return this.$store.state.loginDialog;
    }
  }, {
    key: "isGuest",
    get: function get() {
      return this.$store.getters["configurator/user/isGuest"];
    }
  }, {
    key: "user",
    get: function get() {
      return this.$store.state.configurator.user.user;
    }
  }, {
    key: "login",
    value: function () {
      var _login = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(username, password) {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$store.dispatch("configurator/user/login", {
                  username: username,
                  password: password
                });

              case 2:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function login(_x, _x2) {
        return _login.apply(this, arguments);
      }

      return login;
    }()
  }, {
    key: "logout",
    value: function logout() {
      this.$store.dispatch("configurator/user/logout", {
        root: true
      });
    }
  }, {
    key: "closeLoginDialog",
    value: function closeLoginDialog(c) {
      this.$store.commit("openCloseLoginDialog", c);
    } // watch

  }, {
    key: "title",
    value: function title() {
      return this.isGuest ? "message.Inserisci_i_tuoi_dati" : "ACCOUNT";
    }
  }, {
    key: "validate",
    value: function () {
      var _validate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this2 = this;

        var valid, r;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(this.$refs["loginForm"] != undefined)) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 3;
                return this.$refs["loginForm"].validate();

              case 3:
                valid = _context2.sent;

                if (!valid) {
                  _context2.next = 9;
                  break;
                }

                _context2.next = 7;
                return this.login(this.loginForm.username, this.loginForm.password);

              case 7:
                r = _context2.sent;

                if (this.isGuest) {
                  if (r.data.error) {
                    this.genericLoginError = r.data.msg ? r.data.msg : "Username o password errati";
                  } else {
                    this.genericLoginError = "Username o password errati";
                  }

                  setTimeout(function () {
                    _this2.genericLoginError = "";
                  }, 5000);
                }

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function validate() {
        return _validate.apply(this, arguments);
      }

      return validate;
    }()
  }]);

  return LoginDialog;
}(Vue);

LoginDialog = __decorate([Component({})], LoginDialog);
export default LoginDialog;